// extracted by mini-css-extract-plugin
module.exports = {"updateProfilePage":"ProfileScreen_updateProfilePage___OPgB","myInput":"ProfileScreen_myInput__2Vvlo","signInText":"ProfileScreen_signInText__32iFr"};